module.exports = __webpack_public_path__ + "media/BNP_Samodzielniak_16_D_1.812a5f20.mp3";